import React, { useState, useEffect, useRef } from 'react';
import { motion, AnimatePresence } from 'framer-motion'; // <-- Import motion and AnimatePresence

// --- Static data for the slider ---
const slidesData = [
  { id: 1, title: "Coffee Drinks", image: "/images/menu-hero/hero-1.png" },
  { id: 2, title: "Filter Coffee", image: "/images/menu-hero/hero-2.png" },
  { id: 3, title: "Hot Coffee Drinks", image: "/images/menu-hero/hero-3.png" },
  { id: 4, title: "Balanced Pokes", image: "/images/menu-hero/hero-4.png" }
];

const MenuHeroSlider = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const intervalRef = useRef(null);
  
  const startAutoplay = () => {
    clearInterval(intervalRef.current);
    intervalRef.current = setInterval(() => {
      setCurrentSlide(prev => (prev + 1) % slidesData.length);
    }, 5000);
  };

  useEffect(() => {
    startAutoplay();
    return () => clearInterval(intervalRef.current);
  }, []);

  const handleDotClick = (index) => {
    clearInterval(intervalRef.current);
    setCurrentSlide(index);
    startAutoplay();
  };

  return (
    <div className="menu-hero-slider">
      {/* Background images now render first */}
      {slidesData.map((slide, index) => (
        <div
          key={slide.id}
          className={`menu-hero-slider__slide ${index === currentSlide ? "menu-hero-slider__slide--active" : ""}`}
          style={{ backgroundImage: `url(${slide.image})` }}
        >
          <div className="menu-hero-slider__overlay"></div>
        </div>
      ))}

      {/* The content overlay is now rendered on top */}
      <div className="menu-hero-slider__content">
        <div className="menu-hero-slider__dots">
          {slidesData.map((_, index) => (
            <button
              key={index}
              className={`menu-hero-slider__dot ${index === currentSlide ? "menu-hero-slider__dot--active" : ""}`}
              onClick={() => handleDotClick(index)}
              aria-label={`Go to slide ${index + 1}`}
            />
          ))}
        </div>

        {/* --- THE FIX --- */}
        {/* We use AnimatePresence and a key to make the text re-animate on every slide change */}
        <div className="menu-hero-slider__text-wrapper">
          <AnimatePresence mode="wait">
            <motion.h2
              key={currentSlide} // This forces re-animation
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -30 }}
              transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
              className="menu-hero-slider__title"
            >
              {slidesData[currentSlide].title}
            </motion.h2>
          </AnimatePresence>
        </div>
      </div>
    </div>
  );
};

export default MenuHeroSlider;